/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  MailConnectRequest,
  MailboxChannelResponse
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Spend the state, exchange the code, and record the mailbox.
 *
 * ONE MAILBOX PER ADVISOR, and connecting a second provider is refused rather
 * than added. The table's unique constraint is per provider, so nothing in the
 * database would stop two; what stops them is that a firm's record of what was
 * said to a client should not depend on which of an advisor's accounts they
 * happened to answer from. Disconnecting is one request away, so this is a
 * switch, not a wall.
 * @summary Connect My Mailbox
 */
export const connectMyMailbox = (
    provider: string,
    mailConnectRequest: MailConnectRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<MailboxChannelResponse>(
      {url: `/mailbox/${provider}/connect`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mailConnectRequest, signal
    },
      options);
    }




export const getConnectMyMailboxMutationKey = () => ['connectMyMailbox'] as const;

export const getConnectMyMailboxMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectMyMailbox>>, TError,ConnectMyMailboxMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof connectMyMailbox>>, TError,ConnectMyMailboxMutationVariables, TContext> => {

const mutationKey = getConnectMyMailboxMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectMyMailbox>>, ConnectMyMailboxMutationVariables> = (props) => {
          const {provider,data} = props ?? {};

          return  connectMyMailbox(provider,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectMyMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof connectMyMailbox>>>
    export type ConnectMyMailboxMutationBody = MailConnectRequest
    export type ConnectMyMailboxMutationError = HTTPValidationError
    export type ConnectMyMailboxMutationVariables = {provider: string;data: MailConnectRequest}

    /**
 * @summary Connect My Mailbox
 */
export const useConnectMyMailbox = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectMyMailbox>>, TError,ConnectMyMailboxMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectMyMailbox>>,
        TError,
        ConnectMyMailboxMutationVariables,
        TContext
      > => {
      return useMutation(getConnectMyMailboxMutationOptions(options));
    }
